import type { AdminChatConversationDetails } from '~/services/TripPlannerService';

export function chatSurfacePath(chatId: string | number, origin?: AdminChatConversationDetails['origin']): string {
  return origin?.surface === 'accommodation_offer_page' && origin.offerId
    ? `/offer/${encodeURIComponent(origin.offerId)}?chatId=${encodeURIComponent(chatId)}`
    : `/trip-planner/chat-trip-planner/${encodeURIComponent(chatId)}`;
}
